// extracted by mini-css-extract-plugin
export default {"container":"FilterIconWithLabel_container__kgBM-","filterBadge":"FilterIconWithLabel_filterBadge__k4m3W","filterIcon":"FilterIconWithLabel_filterIcon__9PR-B"};